import React from "react";
import { QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router";
import ToastContextFC from "./context/toast/ToastContext";
import router from "./router/Route";
import queryClient from "./utils/queryClient";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import UserInformationContextFC from "./context/userInformation/UserInformationContext";
import TokenRefreshContextFC from "./context/tokenRefresh/TokenRefreshContext";

function App() {
  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <TokenRefreshContextFC>
            <UserInformationContextFC>
              <ToastContextFC>
                <RouterProvider router={router} />
              </ToastContextFC>
            </UserInformationContextFC>
          </TokenRefreshContextFC>
        </QueryClientProvider>
      </LocalizationProvider>
    </React.Fragment>
  );
}

export default App;
